import { IHttpApi } from '@cian/http-api';
import {
  fetchAddFavorite,
  IAddFavoriteResponse200,
  IAddFavoriteResponse400,
} from '../../repositories/favorites/v1/add-favorite';
import { ResponseError } from '../../utils/errors';
import {
  EDealType,
  EEntityType,
} from '../../repositories/favorites/entities/add_favorite/AddFavoriteEntityPublicRequestSchema';

export interface IAddNewbuildingToFavoritesParameters {
  /** ID ЖК **/
  newbuildingId: number;
}

export async function addNewbuildingToFavorites(httpApi: IHttpApi, parameters: IAddNewbuildingToFavoritesParameters) {
  const response = await fetchAddFavorite<IAddFavoriteResponse200, IAddFavoriteResponse400>({
    httpApi,
    parameters: {
      entityId: parameters.newbuildingId,
      dealType: EDealType.Sale,
      entityType: EEntityType.Newbuilding,
    },
  });

  if (response.statusCode !== 200) {
    const { errors, message } = response.response;

    throw new ResponseError({
      domain: 'shared/services/addNewbuildingToFavorites',
      message: 'Failed adding newbuilding to favorites',
      details: { errors: JSON.stringify(errors), message },
    });
  }

  return response.response;
}
